import React from "react";
import "../../assets/styles/components/model.scss";
import Icon from "@mdi/react";
import {
  mdiClose,
  mdiAlertOutline,
  mdiVanish,
  mdiCheckCircleOutline,
} from "@mdi/js";
import Button from "../button/Button";
import { Spin } from "antd";
interface Props {
  show: boolean;
  type: number;
  onClose?: () => void;
  onSubmit?: () => void;
}

const Model: React.FC<Props> = ({ show, type, onClose, onSubmit }) => {
  const typeModal = [
    {
      text: "ผู้ใช้งานท่านนี้มีประวัติ OPD แล้ว",
      subtext: "This user has a history of OPD.",
      icon: mdiAlertOutline,
      btnTitle: "ดู OPD",
      to: "/opd/search",
    },
    {
      text: "กรุณาเสียบบัตรประชาชนที่ช่องเสียบบัตร",
      subtext: "Please insert your ID card.",
      icon: mdiVanish,
      btnTitle: "ตกลง",
      to: "/opd/create/thai",
      type: "checkidcard",
    },
    {
      text: "ยังไม่มีประวัติ OPD ของผู้ใช้งานท่านนี้\nต้องการเปิด OPD หรือไม่?",
      icon: mdiAlertOutline,
      btnTitle: "ตกลง",
      to: "#",
    },
    {
      text: "ยังไม่มีประวัติ OPD ของผู้ใช้งานท่านนี้\nต้องการเปิด OPD หรือไม่?",
      icon: mdiAlertOutline,
      btnTitle: "ตกลง",
      to: "#",
    },
  ];

  return (
    <div className={`${show ? "modal-open" : "modal-close"}`}>
      <div className="custom">
        <div className="btn-close" onClick={onClose}>
          <Icon path={mdiClose} size="30" />
        </div>
        <div className="modal-contant">
          {typeModal[type].type == "checkidcard" ? (
            <img width="70" height="70" src="spin.gif" />
          ) : (
            <Icon path={typeModal[type].icon} size="70" color="#86CFC6" />
          )}

          <div className="text-contant">{typeModal[type].text}</div>
          <div className="subtext-contant">{typeModal[type].subtext}</div>
          <Button
            title={typeModal[type].btnTitle}
            width={200}
            to={typeModal[type].to}
            onClick={onSubmit}
          ></Button>
        </div>
      </div>
    </div>
  );
};
export default Model;
